import { CURRENT } from 'constants/observationStatuses';
import { DOCUMENT_REFERENCE_TYPE } from 'constants/documentReferenceType';
import axios from '../index';

export const requestDocumentReference = ({ id, elements, author }) =>
  axios.get(`/fhir/DocumentReference`, {
    params: {
      _elements: elements,
      _id: id,
      author,
    },
  });

export const requestDeleteDocumentReference = id => axios.delete(`/fhir/DocumentReference/${id}`);

export const requestUploadDocumentReference = ({
  file: { name, size, data, type } = {},
  patientId,
  author,
  codes,
}) =>
  axios.post(`/fhir/DocumentReference/`, {
    resourceType: 'DocumentReference',
    status: CURRENT,
    indexed: new Date().toISOString(),
    extension: [
      {
        url: 'title',
        valueString: `${name}`,
      },
      {
        url: 'contentType',
        valueString: `${type}`,
      },
      {
        url: 'size',
        valueString: `${size}`,
      },
    ],
    type: {
      coding: codes.map(code => DOCUMENT_REFERENCE_TYPE[code]),
    },
    subject: {
      reference: `Patient/${patientId}`,
    },
    author,
    content: [
      {
        attachment: {
          data,
          contentType: type,
        },
      },
    ],
  });

export const requestUploadDocumentReferenceBatch = ({ docs, patientId, author, codes }) =>
  Promise.all(
    docs.map(file => requestUploadDocumentReference({ file, patientId, author, codes })),
  ).then(response => ({ data: response.map(({ data }) => data.id) }));

export const requestPostDocumentReference = ({ data }) =>
  axios.post(`/fhir/DocumentReference/`, data);
